import { defineStore } from 'pinia'

// Pinia Store
export const useUserStore = defineStore('user', {
  state: () => ({
    // user-selected language
    locale: 'en',
    // auth
    email: [],
    name: {},
    token: null,
    authError: null,
    firstName : null,
    lastName : null,
    displayName : null,
    permissions: {},
    vendorCode : []
  }),
  persist: [
    {
      pick: ['email', 'token', 'permissions'],
      storage: localStorage,
    },
    {
      pick: ['authError'],
      storage: sessionStorage,
    },
  ],
  getters: {
    isGlobalAdmin: (state) => state.permissions.globalAdmin,
    accessibleWorkspaces: (state) => {
      if (state.permissions.globalAdmin) {
        return Object.keys(state.permissions.workspaces)
      }
      return Object.keys(state.permissions.workspaces).filter(w =>
        state.permissions.workspaces[w].access === true
      )
    }
  },
  actions: {
    clearSession() {
      this.email = null
      this.token = null
      this.authError = null
      this.firstName = null
      this.lastName = null
      this.displayName = null
      this.permissions = {}
      this.vendorCode = []
    },
    initPermissions(userData) {
      if (!userData) return
      this.permissions = userData.permissions || { globalAdmin: false, workspaces: {} }
    },
    initVendorCode(userData) {
      if (!userData) return
      if (Array.isArray(userData.vendorCode)) {
        this.vendorCode = userData.vendorCode.map(v => v.value)
      } else {
        this.vendorCode = []
      }
    },
    canAccessWorkspace(workspace) {
      if (this.permissions.globalAdmin) return true
      return this.permissions.workspaces[workspace]?.access === true
    },
    isWorkspaceAdmin(workspace) {
      if (this.permissions.globalAdmin) return true
      return this.permissions.workspaces[workspace]?.isWorkspaceAdmin === true
    },
    canRead(workspace, screen) {
      if (this.permissions.globalAdmin) return true
      if (this.isWorkspaceAdmin(workspace)) return true
      if (!this.canAccessWorkspace(workspace)) return false
      return this.permissions.workspaces[workspace]?.screens[screen]?.read === true
    },
    canWrite(workspace, screen) {
      if (this.permissions.globalAdmin) return true
      if (this.isWorkspaceAdmin(workspace)) return true
      if (!this.canAccessWorkspace(workspace)) return false
      return this.permissions.workspaces[workspace]?.screens[screen]?.write === true
    },

  }
})
